
import { mapGetters, mapState, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { SistemaMixin } from "@/modules/Application";
import { store } from "../../storeLogistica";
import VueSelect from "vue-select";
import _ from "lodash";

export default {
  name: "app-mdfe-form-dadosGeraisTab",
  components: {
    VueSelect
  },
  directives: {
  },
  data() {
    return {
      store,
      motorista: null,
      form: {
        tipo_emissor: null,
        data_jornada: null,
        hora_jornada: null,
        serie: null,
        modelo: null,
      },
      motoristaError: false,
      emissorError: false,
      emissores: [],
      motoristas: [],
    }
  },
  mixins: [
    validationMixin,
    SistemaMixin,
  ],
  methods: {
    ...mapActions(["setLoading"]),
    async getDataInit() {
      this.form.data_jornada = this.thisDate();
      this.form.hora_jornada = this.thisTime();
      const mdfeData = this.$route.params?.mdfeData?.mdfe;
      const [{ data: configData }, {data: emissorData}] = await Promise.all([
        this.$http.post('/configuracoes/current-config', { modelo: 58 }),
        this.$http.post('/mdfe/get-emissor-tipo'),
      ])
      this.form.serie = configData[0]?.serie;
      this.form.modelo = 58;
      this.emissores = emissorData;
      if (mdfeData) {
        this.motorista = mdfeData.motorista;
        this.form.tipo_emissor = this.emissores.find(emissor => emissor.id === mdfeData.tipo_emissor);
        this.form.data_jornada = mdfeData.data_jornada;
        this.form.hora_jornada = mdfeData.hora_jornada;
      }
      this.store.currentTab = 0;
    },
    onSearchMotoristas(search, loading) {
      if (search.length) {
        loading(true);
        this.searchMotoristas(loading, search, this);
      }
    },
    searchMotoristas: _.debounce(async (loading, search, vm) => {
      const { data } = await vm.$http.post('/motoristas/get-motorista', { search });
      vm.motoristas = data;
      if (loading) loading(false);
    }, 350),
    validateState(field) {
      return !!this.form[field];
    }
  },
  created() {
    this.getDataInit();
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig"
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
    isTheCurrentTab() {
      return store.currentTab === 0
    }
  },
  watch: {
    "store.currentTab"(newValue, oldValue) {
      if (newValue !== oldValue && newValue === 1 && oldValue < newValue) {
        if (!this.motorista) {
          this.$toast.error('Motorista Obrigatorio!')
          this.motoristaError = true;
          this.store.currentTab = oldValue;
        }
        if (!this.form.tipo_emissor) {
          this.$toast.error('Tipo emissor obvrigatório!')
          this.emissorError = true;
          this.store.currentTab = oldValue;
        }
        if (!this.form.hora_jornada) {
          this.$toast.error('Hora de jornada obrigatória!')
          this.store.currentTab = oldValue;
        }
        if (!this.form.data_jornada) {
          this.$toast.error('Data de jornada obrigatória!')
          this.store.currentTab = oldValue;
        }
      }
      this.store.formData = {
        ...this.store.formData,
        ...this.form,
        motorista: this.motorista,
        tipo_emissor: this.form.tipo_emissor.id,
      }
    },
  }
}

